const getters = {
  /**
   * Get current user
   * @param state
   * @returns {{name:String, email:String, title:String}}
   */
  user: state => {
    return state.user;
  },
  userContracts: state => {
    return state.userContracts;
  },
  userPermissions: state => {
    return state.userPermissions;
  },
  unConstructedUserPermissions: state => {
    return state.unConstructedUserPermissions;
  },
  keycloak: state => {
    return state.keycloak;
  }
};

export default getters;
